/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GrundstueckTypAuswahl { 
    sucheLig?: boolean;
    sucheSdr?: boolean;
    sucheStw?: boolean;
    sucheMit?: boolean;
    sucheFolio?: boolean;
    sucheUnbekannt?: boolean;
    sucheSdrUnterart?: GrundstueckTypAuswahl.SucheSdrUnterartEnum;
}
export namespace GrundstueckTypAuswahl {
    export type SucheSdrUnterartEnum = 'BAURECHT' | 'QUELLENRECHT' | 'KONZESSION' | 'UEBRIGES_RECHT';
    export const SucheSdrUnterartEnum = {
        BAURECHT: 'BAURECHT' as SucheSdrUnterartEnum,
        QUELLENRECHT: 'QUELLENRECHT' as SucheSdrUnterartEnum,
        KONZESSION: 'KONZESSION' as SucheSdrUnterartEnum,
        UEBRIGES_RECHT: 'UEBRIGES_RECHT' as SucheSdrUnterartEnum
    };
}


